module.exports = __webpack_public_path__ + "media/images/client-6-b8da9be2c8d216368b0efc067bdc4f88.png";